import React, { useState } from 'react';
import { MultiSwitch } from '../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { ClosedPositionsTable } from './collections/ClosedPositionsTable';
import style from './ClosedPositions.module.css';
import { Body3 } from '../../../../../atomic/text/Text';
import { colors } from '../../../../../../colorVars';

const labels = ['Position', 'Symbol', 'Underlying', 'Trade Plan', 'Template'];
const values = [
  'byPosition',
  'bySymbol',
  'byUnderlying',
  'byTradePlan',
  'byTemplate',
];

export const ClosedPositions = () => {
  const [switchValue, setSwitchValue] = useState('byPosition');

  return (
    <div className={style.div}>
      <header className={style.header}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Sort By:{' '}
        </Body3>
        <MultiSwitch
          labels={labels}
          values={values}
          setValue={setSwitchValue}
          controlledValue={switchValue}
          margin="5px"
        />
      </header>
      <div className={style.tableContainer}>
        <table className={style.table}>
          <ClosedPositionsTable sortingKeyword={switchValue} />
        </table>
      </div>
    </div>
  );
};
